import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { EnumResponse } from '../../models/EnumResponse';
import { EstatusJSON } from '../../models/EstatusJSON';
import { IApiBase } from './Interface/IApiBase.interface';
import { CatalogPaginationRequest } from '../../models/CatalogPagination/CatalogPaginationRequest';
import { FilterRequest } from '../../models/Filter/FilterRequest';
@Injectable({
    providedIn: 'root'
  })


export class EnumsAPIService implements IApiBase{
  private configUrl: string;

  public enumCatalog: EnumResponse[] = [];

  subscription_setEnumCatalogs: Subscription;

  constructor(
    private http: HttpClient){
    this.configUrl = environment.host;
  }
  insert() {
    throw new Error('Method not implemented.');
  }
  update(datos: any) {
    throw new Error('Method not implemented.');
  }
  delete(id: any) {
    throw new Error('Method not implemented.');
  }
  getFilterValues(request: FilterRequest[]) {
    throw new Error('Method not implemented.');
  }
  getPage(pageRequest: CatalogPaginationRequest) {
    throw new Error('Method not implemented.');
  }
  getCount(pageRequest: CatalogPaginationRequest) {
    throw new Error('Method not implemented.');
  }

  GetAll(){
    if(!environment.production) console.log(this.configUrl + "/api/EnumCatalog/GetAll");
    return this.http.get<EstatusJSON>(this.configUrl + "/api/EnumCatalog/GetAll");
  }

  GetByEnumAPI(enumName: string){
    if(!environment.production) console.log(this.configUrl + "/api/EnumCatalog/GetByEnum");
    return this.http.get<EstatusJSON>(this.configUrl + "/api/EnumCatalog/GetByEnum?enumName=" + enumName);
  }
}
